import store from '@/store';

export default (to, from, next) => {
    const is_mobile_group_allowed = store.getters.is_app_environment_enabled_mobile_groups_menu_item;

    return {
        allow: is_mobile_group_allowed,
        redirect: { name: 'not-found' },
    }
};
